(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dawenha-agenda-quiz"] && !Shopify.designMode) return;
  try {
    
(() => {
  const codes = ['M','L','B','S','H','N','F'];
  const maps = ['MLBSHNF','LBSHNFM','BSHNFML','SHNFMLB','HNFMLBS','NFMLBSH','FMLBSHN','MHBFSLN','MLBSHNF','MLBSHNF'];
  function evaluate(answers) {
    if (answers.length !== 10 || answers.some(a => !Number.isInteger(a) || a < 0 || a > 6)) throw new Error('Incomplete answers');
    const scores = Object.fromEntries(codes.map(c => [c,0]));
    const core = {...scores};
    const picked = answers.map((a,i) => maps[i][a]);
    picked.forEach((c,i) => { scores[c] += i < 7 ? 2 : 1; if(i < 7) core[c]++; });
    const compare = (a,b) => scores[b]-scores[a] || core[b]-core[a] || Number(b===picked[8])-Number(a===picked[8]) || Number(b===picked[9])-Number(a===picked[9]);
    const ranked = [...codes].sort(compare);
    const leader = ranked[0];
    const gap = scores[leader] - scores[ranked[1]];
    const unresolved = ranked.filter(c => compare(c,leader) === 0);
    if (unresolved.length > 1) return {codes:unresolved.slice(0,2),kind:'compare',scores,core};
    if (gap >= 3 && core[leader] >= 4) return {codes:[leader],kind:'strong',scores,core};
    if (gap <= 2) return {codes:[leader],kind:'tentative',scores,core};
    return {codes:ranked.slice(0,2),kind:'compare',scores,core};
  }
  if (customElements.get('dawenha-agenda-quiz')) return;
  customElements.define('dawenha-agenda-quiz', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.answers = Array(10).fill(null);
      this.step = 0;
      this.busy = false;
      this.added = new Set();
      this.strings = this.querySelector('[data-strings]').dataset;
      this.fields = [...this.querySelectorAll('[data-question]')];
      this.querySelector('[data-start]').addEventListener('click', () => this.showQuestion());
      this.querySelector('[data-back]').addEventListener('click', () => { if(this.step > 0) this.step--; this.showQuestion(); });
      this.querySelector('[data-next]').addEventListener('click', () => {
        if (this.answers[this.step] === null) { this.querySelector('[data-question-error]').hidden=false; return; }
        if (this.step < 9) { this.step++; this.showQuestion(); } else this.showResults();
      });
      this.querySelector('[data-edit]').addEventListener('click', () => { if(!this.busy) this.showQuestion(); });
      this.querySelector('[data-restart]').addEventListener('click', () => {
        if(this.busy) return;
        this.answers.fill(null); this.step=0;
        this.querySelectorAll('input[type=radio]').forEach(el => el.checked=false);
        this.showQuestion();
      });
      this.addEventListener('change', event => {
        const field = event.target.closest('[data-question]');
        if(field && event.target.matches('input[type=radio]')) {
          this.answers[Number(field.dataset.question)] = Number(event.target.value);
          this.querySelector('[data-next]').disabled = false;
          this.querySelector('[data-question-error]').hidden = true;
          this.updateProgress();
        }
        if(event.target.matches('select[name=id]')) {
          const card=event.target.closest('.dq-card');
          card.querySelector('[data-price]').textContent=event.target.selectedOptions[0].dataset.price;
          this.syncForm(card.querySelector('form'));
        }
      });
      this.addEventListener('submit', event => {
        if(!event.target.matches('[data-add-form]')) return;
        event.preventDefault();
        this.addToCart(event.target);
      });
    }
    updateProgress() {
      this.querySelector('[data-progress]').value=this.answers.filter(a => a!==null).length;
    }
    showQuestion() {
      const introBanner = this.querySelector('[data-intro-banner]');
      if (introBanner) introBanner.hidden = true;
      this.querySelector('[data-intro]').hidden=true;
      this.querySelector('[data-results]').hidden=true;
      this.querySelector('[data-questions]').hidden=false;
      this.fields.forEach((f,i)=>f.hidden=i!==this.step);
      this.querySelector('[data-count]').textContent=(this.step+1).toLocaleString('ar-EG');
      this.querySelector('[data-back]').disabled=this.step===0;
      this.querySelector('[data-next]').disabled=this.answers[this.step]===null;
      this.querySelector('[data-next-label]').hidden=this.step===9;
      this.querySelector('[data-finish-label]').hidden=this.step!==9;
      this.querySelector('[data-question-error]').hidden=true;
      this.updateProgress();
      this.fields[this.step].querySelector('legend').focus();
    }
    showResults() {
      const result=evaluate(this.answers);
      this.querySelector('[data-questions]').hidden=true;
      this.querySelector('[data-results]').hidden=false;
      const title=this.querySelector('[data-result-title]');
      title.textContent=this.strings[result.codes.length===2?'two':'result'];
      this.querySelector('[data-result-note]').textContent=this.strings[result.kind];
      const cards=this.querySelector('[data-cards]');
      cards.replaceChildren();
      result.codes.forEach(code => cards.append(this.querySelector(`template[data-product="${code}"]`).content.cloneNode(true)));
      cards.querySelectorAll('form').forEach(form => this.syncForm(form));
      title.focus();
    }
    syncForm(form) {
      const id=new FormData(form).get('id');
      const button=form.querySelector('button');
      if(!button.dataset.original) { button.dataset.original=button.textContent; button.dataset.available=String(!button.disabled); }
      const added=this.added.has(String(id));
      button.disabled=this.busy || added || button.dataset.available==='false';
      button.textContent=added?this.strings.added:button.dataset.original;
      form.querySelector('[data-cart-link]').hidden=!added;
      form.querySelector('[data-cart-status]').textContent='';
    }
    async addToCart(form) {
      if(this.busy) return;
      const id=String(new FormData(form).get('id') || '');
      if(!/^\d+$/.test(id) || this.added.has(id)) return;
      const button=form.querySelector('button');
      if(button.disabled) return;
      const status=form.querySelector('[data-cart-status]');
      this.busy=true;
      this.querySelectorAll('[data-add-form] button, [data-edit], [data-restart]').forEach(el=>el.disabled=true);
      button.textContent=this.strings.adding;
      status.textContent='';
      let succeeded=false;
      try {
        const response=await fetch(this.dataset.addUrl, {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id,quantity:1}]})});
        const data=await response.json();
        if(!response.ok) throw new Error(data.description || this.strings.error);
        this.added.add(id);
        succeeded=true;
      } catch(error) {
        status.textContent=this.strings.error;
        if(error.message && error.message!==this.strings.error && !/fetch|network|json|unexpected/i.test(error.message)) status.textContent+=' '+error.message;
      } finally {
        this.busy=false;
        this.querySelectorAll('[data-add-form]').forEach(other=>{
          const otherButton=other.querySelector('button');
          const already=this.added.has(String(new FormData(other).get('id')));
          otherButton.disabled=already || otherButton.dataset.available==='false';
          otherButton.textContent=already?this.strings.added:otherButton.dataset.original;
        });
        this.querySelectorAll('[data-edit], [data-restart]').forEach(el=>el.disabled=false);
        form.querySelector('[data-cart-link]').hidden=false;
      }
      if(succeeded) {
        status.textContent=this.strings.added;
        window.location.assign(this.dataset.cartUrl);
      }
    }
  });
})();


  } catch(e) { console.error(e); }
})();
})();
